












import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {mixin as clickaway} from 'vue-clickaway';
import {ConditionViewModel} from './models/conditionViewModel';
import {ConditionPickerOption} from './models/conditions';
import Icon from '../../icons/Icon.vue';

@Component({
	mixins: [
		clickaway,
	],
	components: {
		Icon
	}
})
export default class ConditionPicker extends Vue {
	@Prop() public availableConditions: ConditionPickerOption[];

	public getIconComponent(option: ConditionPickerOption) {
		if (option && option.icon) {
			return option.icon;
		}

		return '';
	}

	public chooseOption(option: ConditionPickerOption) {
		const condition: ConditionViewModel = {
			attribute: option.id,
			operation: '',
			type: option.type,
			unit: '',
			value: '',
			result: true
		};

		this.$emit('selected', condition);
	}
}
